import * as React from 'react'
import styled from 'styled-components'
import { fontSizes, screenSizes } from '@src/styles/theme'
import { panelRadius } from '@components/panels/panels'

const Grid = styled.div<any>`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: ${screenSizes.L}px) {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: ${screenSizes.S}px) {
    grid-template-columns: 1fr;
  }
`

const Card = styled.div<any>`
  background: ${(props: any) => props.theme.panelBack};
  border-radius: ${panelRadius};
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const Label = styled.span<any>`
  font-size: 13px;
  color: ${(props: any) => props.theme.listDesc || '#9CA6AD'};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  font-family: 'NunitoSansSemiBold';
`

const Value = styled.span<any>`
  font-size: ${fontSizes.L};
  font-family: 'NunitoSansSemiBold';
  color: ${(props: any) => props.theme.white};
  line-height: 1.1;
`

const Subtitle = styled.span<any>`
  font-size: 13px;
  color: ${(props: any) => props.theme.listDesc || '#9CA6AD'};
`

interface MetricItem {
  label: string
  value: string | number
  subtitle?: string
}

interface MetricsRowProps {
  metrics: MetricItem[]
}

export const MetricsRow: React.FC<MetricsRowProps> = ({ metrics }) => {
  return (
    <Grid>
      {metrics.map((m, i) => (
        <Card key={i}>
          <Label>{m.label}</Label>
          <Value>{typeof m.value === 'number' ? m.value.toLocaleString() : m.value}</Value>
          {m.subtitle && <Subtitle>{m.subtitle}</Subtitle>}
        </Card>
      ))}
    </Grid>
  )
}
